import React, { Component } from "react";
import { connect } from "react-redux";
import spinner from '../assets/img/svg/loading.svg';
import withRouter from "../components/custom/withRouter";

class PageLoader extends Component {
  constructor(props){
    super(props);
  }
  render() {
    return (<>
      {this.props.loading ? 
      <div className="App">
        <div className="spinner_overlay" >
          <div className="loader">
            <img src={spinner} alt="loading..." /><span><h3>Loading...</h3></span>
          </div>
        </div >
      </div> : <></> }
      </>);
  }
}

function mapDispatchToProps(dispatch) {
  return {
      dispatch,
  };
}

function mapStateToProps(state) {
  return {
      loading: state.commonReducer.loading,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageLoader)
);
